import { useCallback } from "react";
import type { Dispatch, SetStateAction } from "react";
import type { NavigateFunction } from "react-router-dom";
import { useTelegramBackButton } from "../../hooks/useTelegramBackButton";
import type { ScreenType } from "./types";

export interface UseCityHallBackButtonParams {
  currentScreen: ScreenType;
  navigate: NavigateFunction;
  onClose: (() => void) | undefined;
  setCurrentScreen: Dispatch<SetStateAction<ScreenType>>;
}

/**
 * Back-button policy for the town hall: on the main screen back leaves the
 * building, anywhere else it returns to the main screen.
 *
 * Call site matters: the useCallback and the useTelegramBackButton
 * subscription keep the same relative position they had inline.
 */
export function useCityHallBackButton({
  currentScreen,
  navigate,
  onClose,
  setCurrentScreen,
}: UseCityHallBackButtonParams): void {
  // Використовуємо нативну кнопку назад від Telegram для всіх екранів (включно з головним)
  const handleBack = useCallback(() => {
    if (currentScreen === "main") {
      // На головному екрані - закриваємо мерію (як в RealEstateInfoModal)
      if (onClose) {
        onClose();
      } else {
        navigate("/map");
      }
    } else {
      // На інших екранах - повертаємося на головний
      setCurrentScreen("main");
    }
    // `setCurrentScreen` is only in this dep list because, as a parameter, the
    // lint rule can no longer see that it is a useState setter. React
    // guarantees setter identity is stable, so the callback identity behaves
    // exactly as it did inline.
  }, [currentScreen, onClose, navigate, setCurrentScreen]);
  useTelegramBackButton(true, handleBack);
}
